/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/474-chrome': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4.036 6.977l-2.29-3.966A7.986 7.986 0 018-.001a7.994 7.994 0 016.883 3.922H8.355a4.1 4.1 0 00-4.32 3.055zm6.828-1.899h4.585a8 8 0 01-7.358 10.921l3.272-5.667a4.08 4.08 0 00-.499-5.254zM5.094 8c0-1.603 1.304-2.906 2.906-2.906S10.906 6.398 10.906 8 9.602 10.906 8 10.906 5.094 9.602 5.094 8zm4.003 3.944l-2.29 3.967a8.001 8.001 0 01-5.78-11.833l3.266 5.657a4.1 4.1 0 004.804 2.21z"/>'
  }
})
